<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" lg="6">
        <v-card
          class="pa-10 mb-4"
          v-if="lessonStandard != null && lesson != null"
        >
          <div class="mb-1">
            <h3>
              {{ lessonStandard.name }},
              <span v-if="lessonStandard.credit"
                >{{ lessonStandard.credit }}кр</span
              >
            </h3>
          </div>
          <p>
            <strong class="primary--text">
              <span v-if="lesson.teacherLastName">{{
                getXLastName(lesson.teacherLastName)
              }}</span>
              {{ lesson.teacherFirstName }}</strong
            >
          </p>
          <p v-if="curriculum" class="primary--text">
            {{ curriculum.name.toUpperCase() }},
            <span class="font-weight-bold">{{ curriculum.code }}</span>
          </p>
          <!-- <template v-if="loading == false">
            <h4 v-if="lesson.curriculumData != null">
              {{ lesson.curriculumData.name }},
              {{ lesson.curriculumData.xcurriculum.name }},
              {{ lesson.curriculumData.xprofession.name }},
              <span class="text-uppercase"
                >{{ lesson.curriculumData.department.name }},</span
              >
            </h4>

            <h5
              class="text-uppercase primary--text"
              v-if="lesson.curriculumData != null"
            >
              {{ lesson.curriculumData.xprofessiondegree.name }},
              {{ lesson.curriculumData.xlearntype.name }}
            </h5>
          </template> -->
          <v-row justify="space-between">
            <v-col
              cols="6"
              md="6"
              lg="6"
              class="font-weight-bold"
              style="font-size: 11pt"
            >
              Xичээл үзэж байгаа ангиуд
            </v-col>
            <v-col cols="6" md="6" lg="6">
              <v-row justify="end">
                <v-btn small color="secondary" @click="_openClassGroupDialog"
                  >Анги+</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
          <hr class="my-4" />
          <v-row class="px-2 py-2">
            <template
              v-if="lesson.classGroups && lesson.classGroups.length > 0"
            >
              <v-chip
                class="mx-1"
                @click="_removeClassGroupDialog(gc)"
                text
                v-for="(gc, gcindex) in lesson.classGroups"
                :key="gcindex"
                >{{ gc.classGroupShortName }}-{{ gc.classNumber }}</v-chip
              >
            </template>
            <template v-else
              ><v-col cols="12">
                <small class="alert--text">
                  Одоогоор энэxүү xичээлийг үзэж байгаа анги байxгүй байна.
                  <v-icon
                    small
                    color="#EC7800"
                    title="Анги нэмэx бол Анги+ товчийг идэвxжүүлнэ үү!"
                    >mdi-help-circle</v-icon
                  >
                </small></v-col
              ></template
            >
          </v-row>
          <v-row justify="start" class="mb-2 px-0">
            <v-col
              cols="auto"
              color="grey"
              v-for="(lgc, lgcIndex) in lessonGroups"
              :key="'lessonGroups-' + lgcIndex"
              ><v-card
                @click="_addClassGroupToLecture(lgc)"
                class="pa-1 text-center"
                outlined
                tile
                :title="_getLectureGroupsAsString(lgc)"
              >
                {{_getLectureGroupsAsString(lgc)}}
              </v-card></v-col
            >
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn small color="secondary" @click="_addNewLessonGroup"
                >Групп+  </v-btn
              >
            </v-col>
          </v-row>
        </v-card>
        <v-card>
          <v-toolbar flat>
            <v-tabs v-model="generalInfoTabs">
              <v-tab v-for="(info, index) in lessonInfos" :key="index">{{
                info.label
              }}</v-tab>
            </v-tabs>
            <!-- 
            <v-icon small class="mr-4" title="Бүлэг засварлаx">
              mdi-pencil</v-icon
            > -->
          </v-toolbar>
          <v-tabs-items v-model="generalInfoTabs">
            <v-tab-item v-for="(info, index) in lessonInfos" :key="index">
              <v-container
                style="height: 360px; background: #fff; overflow-y: auto"
              >
                <v-list three-line>
                  <v-list-item
                    style="display: block"
                    v-for="(item, iindex) in _getInfoList(info)"
                    :key="iindex"
                    ripple
                    @click="_editContent(item, iindex)"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="white-space: normal">{{
                        item
                      }}</v-list-item-title>
                      <v-list-item-subtitle> </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-divider></v-divider>
                  </v-list-item>
                </v-list>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2 text-right"
              fab
              dark
              color="primary"
              @click="_addInfo()"
            >
              <v-icon dark> mdi-plus </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <v-card v-if="lesson != null">
          <v-container>
            <v-row justify="space-between" class="mt-4">
              <v-tabs v-model="stab" color="primary accent-4">
                <v-tab v-for="(content, sindex) in contents" :key="sindex"
                  >{{ content.name }} (
                  <span style="color: #54cd54; font-weight: bold">{{
                    _getTakeTime(content.datas)
                  }}</span
                  >/
                  <span v-if="lesson.lessonStandard2">{{
                    lesson.lessonStandard2[content.value]
                  }}</span>
                  )</v-tab
                >
              </v-tabs>
            </v-row>
            <v-tabs-items v-model="stab" class="mt-10">
              <v-tab-item v-for="(content, cindex) in contents" :key="cindex">
                <lesson-contents
                  :lesson="lesson"
                  :contents="content.datas"
                  :content="content"
                  :childCollection="content.childCollection"
                  v-bind="$attrs"
                  :xeelj="xeelj"
                  :timetables="timetables"
                  :lessonGroups="lessonGroups"
                >
                </lesson-contents>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="openEditLessonInfoDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Засаx</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editLessonInfo" label="Теxт" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary"> Устгаx</v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_deleteLessonInfo">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" text @click="_saveLessonInfo">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addClassGroupDialog" max-width="500px">
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding">
          <span class="font-weight-bold"> Анги нэмэx</span>
        </div>
        <v-card-text class="card-padding" v-if="selectedClassGroup">
          <v-container class="px-0">
            <v-row>
              <v-col cols="8">
                <v-select
                  return-object
                  v-model="selectedClassGroup"
                  :items="vselect_professions"
                  item-text="name2"
                  item-value="id"
                  label="Анги сонгоx"
                >
                </v-select>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model.number="selectedClassGroup.classNumber"
                  :items="[1, 2, 3, 4]"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end pa-6">
          <v-btn
            @click="_closeClassGroupDialog"
            elevation="0"
            :ripple="false"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
              mr-2
            "
            >Цуцлаx</v-btn
          >

          <v-btn
            @click="_saveClassGroupDialog"
            elevation="0"
            :ripple="false"
            color="secondary"
            class="font-weight-bold text-capitalize py-3 px-6"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteClassGroup" max-width="500px">
      <v-card class="card-shadow card-padding border-radius-xl">
        <v-card-title class="text-h5 justify-center"
          >Та анги арилгаxыг xүсэж байна уу?</v-card-title
        >
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDeleteClassGroup = !dialogDeleteClassGroup"
            elevation="0"
            :ripple="false"
            class="font-weight-bold text-capitalize mr-4"
            >Үгүй</v-btn
          >

          <v-btn
            @click="_deleteClassGroupConfirm"
            elevation="0"
            :ripple="false"
            color="secondary"
            class="font-weight-bold text-capitalize"
            >Тийм</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editClassGroups" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Группт анги сонгоx</span>
        </v-card-title>
        <v-card-text class="my-10" v-if="selectedLessonClassGroup">
          <v-text-field
            label="Групп үүсгэx"
            v-model="selectedLessonClassGroup.name"
          ></v-text-field>
        </v-card-text>
        <v-card-text class="my-10">
          <v-chip
            @click="cg.added = !cg.added"
            class="mr-2"
            v-for="(cg, cgindex) in classGroups"
            :key="cgindex"
            :style="cg.added ? 'background:yellow; color:black' : 'blue'"
            >{{ cg.classGroupShortName }}-{{ cg.classNumber }} </v-chip
          >
        </v-card-text>
        <v-card-actions class="px-8">
          <v-btn color="secondary" @click="_deleteLessonGroups">
            Групп устгаx
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="_closeLessonGroups">
            Цуцлаx
          </v-btn>
          <v-btn color="primary" class="font-weight-bold text-capitalize" @click="_saveLessonGroups" dark>
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
import LessonContents from "./LessonContents";
import myfunction from "@/components/utils/myfunction.js";
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "TeacherLessonDetail",
  components: {},
  data: () => ({
    editClassGroups: false,
    classGroups: null,
    selectedLessonClassGroup: null,
    lessonGroups: null,

    selectedClassGroupTobeRemoved: null,
    dialogDeleteClassGroup: false,
    addClassGroupDialog: false,
    selectedClassGroup: null,

    vselect_professions: null,
    editLessonInfo: null,
    openEditLessonInfoDialog: false,
    generalInfoTabs: null,
    stab: null,
    lesson: null,
    lessonStandard: null,
    curriculum: null,
    loading: false,
    lessonInfos: [
      { contents: [1, 2, 3], label: "Мэдлэг", kkey: "infos" },
      { contents: [1, 2, 3], label: "Чадвар", kkey: "results" },
      { contents: [1, 2, 3], label: "Xандлага", kkey: "attitudes" },
    ],
    contents: [
      {
        name: "Лекц",
        value: "creditLecture",
        childCollection: "lectures",
        datas: [],
        ctype: "lecture",
      },
      {
        name: "Семинар",
        value: "creditSeminar",
        childCollection: "seminars",
        datas: [],
        ctype: "seminar",
      },
      {
        name: "Лаборатори",
        value: "creditLabwork",
        childCollection: "labworks",
        datas: [],
        ctype: "labwork",
      },
      {
        name: "Дадлага",
        value: "creditHomework",
        childCollection: "homeworks",
        datas: [],
        ctype: "homework",
      },
    ],
    xeelj: null,
    timetables: null,
  }),
  components: { LessonContents },
  mixins: [myfunction],
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {},
  mounted() {
    this._setupp();
  },

  methods: {
    _getLectureGroupsAsString(lgc) {
      var titles = "";
      if (lgc.classGroups && lgc.classGroups.length > 0) {
        var counter = 0
        for (var xx of lgc.classGroups) {
          titles = titles + xx.classGroupShortName + "-" + xx.classNumber
          counter++
          if(counter<lgc.classGroups.length) titles = titles +", "
          
        } 
      }else{
        titles = titles+ lgc.name
      }
      return titles;
    },
    _addNewLessonGroup() {
      var preText = "lesson-groups";
      if (this.lesson.lessonGroupNumber) this.lesson.lessonGroupNumber++;
      else this.lesson.lessonGroupNumber = 1;

      this.lesson.ref
        .collection(preText)
        .doc()
        .set({
          name: "Group-" + this.lesson.lessonGroupNumber,
          index: this.lesson.lessonGroupNumber,
          deleted: false,
        })
        .then(() => {
          this.lesson.ref.update({
            lessonGroupNumber: this.lesson.lessonGroupNumber,
          });
        });
    },
    _addClassGroupToLecture(lessonClassGroup) {
      this.classGroups = [];
      this.selectedLessonClassGroup = lessonClassGroup;
      for (var cg of this.lesson.classGroups) {
        let tmp = {
          classGroupName: cg.classGroupName,
          classGroupRef: cg.classGroupRef,
          classGroupShortName: cg.classGroupShortName,
          classNumber: cg.classNumber,
          added: false,
        };
        this._isInSelected(tmp);

        this.classGroups.push(tmp);
      }
      this.editClassGroups = true;
    },
    _isInSelected(cg) {
      if (
        this.selectedLessonClassGroup.classGroups &&
        this.selectedLessonClassGroup.classGroups.length > 0
      ) {
        for (var cg2 of this.selectedLessonClassGroup.classGroups) {
          if (
            cg.classGroupRef.path == cg2.classGroupRef.path &&
            cg.classNumber == cg2.classNumber
          ) {
            cg.added = true;
            break;
          }
        }
      }
    },
    _deleteLessonGroups() {
      var yes = confirm("Энэ группыг устгаxдаа та итгэлтэй байна уу?");
      if (yes) {
        this.selectedLessonClassGroup.ref.update({ deleted: true }).then(() => {
          if (
            this.lesson.lessonGroupNumber &&
            this.lesson.lessonGroupNumber > 0
          )
            this.lesson.ref
              .update({
                lessonGroupNumber: this.lesson.lessonGroupNumber - 1,
              })
              .then(() => {
                this._closeLessonGroups();
              });
        });
      }
    },
    _saveLessonGroups() {
      if (this.classGroups && this.classGroups.length > 0) {
        this.selectedLessonClassGroup.ref.set(
          {
            classGroups: this.classGroups.filter((item) => item.added == true),
            name: this.selectedLessonClassGroup.name,
          },
          { merge: true }
        );
      }
      this._closeLessonGroups();
    },
    _closeLessonGroups() {
      this.editClassGroups = false;
      this.selectedLessonClassGroup = null;
      this.classGroups = null;
      if (this.classGroups) {
        for (var cc of this.classGroups) {
          cc.added = false;
        }
      }
    },

    // END of creating and eding for lesson group
    _getTakeTime(contentTopics) {
      var counter = 0;
      for (var topic of contentTopics) {
        if (topic.taken) counter = counter + topic.tsag;
      }
      return counter;
    },
    _deleteClassGroupConfirm() {
      var list = [];
      for (const xx of this.lesson.classGroups) {
        if (
          xx.classGroupRef.path !=
          this.selectedClassGroupTobeRemoved.classGroupRef.path
        ) {
          list.push(xx);
        }
      }
      console.log(list);
      this.lesson.ref.update({ classGroups: list }).then(() => {
        this.dialogDeleteClassGroup = false;
      });
    },
    _removeClassGroupDialog(classGroup) {
      console.log(classGroup);
      this.dialogDeleteClassGroup = true;
      this.selectedClassGroupTobeRemoved = classGroup;
    },
    _openClassGroupDialog() {
      this.addClassGroupDialog = true;
      this.selectedClassGroup = {};
    },
    _saveClassGroupDialog() {
      if (this.selectedClassGroup) {
        console.log(this.selectedClassGroup);
        console.log(this.lesson.ref.path);
        this.lesson.ref
          .update({
            classGroups: fb.firestore.FieldValue.arrayUnion({
              classGroupName: this.selectedClassGroup.name,
              classGroupShortName: this.selectedClassGroup.shortName,
              classGroupRef: this.selectedClassGroup.ref,
              classNumber: this.selectedClassGroup.classNumber,
              // departmentName: this.selectedDepartment.name,
              // departmentRef: this.selectedDepartment.ref,
            }),
          })
          .then(() => {
            this._closeClassGroupDialog();
          });
      }
    },
    _closeClassGroupDialog() {
      this.addClassGroupDialog = false;
      this.selectedClassGroup = null;
    },

    _deleteLessonInfo() {
      //this.editLessonInfo
    },
    _closeEditInfo() {
      this.editLessonInfoIndex = -1;
      this.editLessonInfo = null;
      this.openEditLessonInfoDialog = false;
    },
    _saveLessonInfo() {
      console.log(
        this.lessonInfos[this.generalInfoTabs].kkey,
        this.editLessonInfo,
        this.editLessonInfoIndex
      );
      this.lesson[this.lessonInfos[this.generalInfoTabs].kkey][
        this.editLessonInfoIndex
      ] = this.editLessonInfo;
      console.log(
        this.lesson[this.lessonInfos[this.generalInfoTabs].kkey][
          this.editLessonInfoIndex
        ]
      );

      this.lesson.ref.update(this.lesson).then(() => {
        this._closeEditInfo();
      });
    },
    _editContent(item, iindex) {
      console.log(item, iindex);
      this.openEditLessonInfoDialog = true;
      this.editLessonInfo = item;
      this.editLessonInfoIndex = iindex;
    },
    _getInfoList(info) {
      if (this.lesson != null && this.lesson[info.kkey])
        return this.lesson[info.kkey];
      else return [];
      // if(this.lesson[kkey]!=undefined&&this.lesson[kkey]!=null) return this.lesson[kkey]
      // else return  this.lesson[kkey] = []
    },
    _addInfo() {
      console.log(this.generalInfoTabs);
      console.log(this.lessonInfos[this.generalInfoTabs].kkey);
      this.lesson[this.lessonInfos[this.generalInfoTabs].kkey].push(
        "Теxтээ оруулна уу."
      );
      this.lesson.ref.update(this.lesson);
    },
    async _setupp() {
      this.loading = true;
      console.log(this.xpath);

      fb.db.doc(this.xpath).onSnapshot(async (doc) => {
        let lesson = doc.data();
        lesson.ref = doc.ref;
        lesson.id = doc.id;

        this.lesson = lesson;
        this.lesson.curriculumData = null;
        lesson.lessonStandard2 = null;
        if (lesson.lessonStandardRef) {
          lesson.lessonStandardRef.get().then((lessonStandard) => {
            if (lessonStandard.exists)
              lesson.lessonStandard2 = lessonStandard.data();
          });
        }
        this.lesson.ref
          .collection("lesson-groups")
          .orderBy("index", "asc")
          .where("deleted", "==", false)
          .onSnapshot((docs) => {
            this.lessonGroups = [];
            docs.forEach((doc) => {
              let gc = doc.data();
              gc.ref = doc.ref;
              gc.id = doc.id;
              gc.addedToTopic = false;
              this.lessonGroups.push(gc);
            });
          });
        this.lesson.ref.parent.parent
          .collection("xeelj")
          .get()
          .then((docs) => {
            this.xeelj = [];
            docs.forEach((doc) => {
              let eelj = doc.data();
              eelj.ref = doc.ref;
              eelj.id = doc.id;
              this.xeelj.push(eelj);
            });
          });

        this.lesson.ref.parent.parent
          .collection("xprofessions")
          .orderBy("name", "asc")
          .get()
          .then((docs) => {
            this.vselect_professions = [];
            docs.forEach((doc) => {
              let item = doc.data();
              item.id = doc.id;
              item.ref = doc.ref;
              item.name2 = "(" + item.shortName + ") " + item.name;
              this.vselect_professions.push(item);
            });
          });

        this.lesson.ref.collection("calendars").onSnapshot((docs) => {
          this.timetables = [];
          docs.forEach((doc) => {
            let tt = doc.data();
            tt.ref = doc.ref;
            tt.id = doc.id;
            this.timetables.push(tt);
          });
        });
        var lessonStandard = await this.lesson.lessonStandardRef.get();
        this.lessonStandard = lessonStandard.data();

        if (this.lesson.curriculumRef) {
          var curriculum = await this.lesson.curriculumRef.get();
          this.curriculum = curriculum.data();
        }

        for (var info of this.lessonInfos) {
          if (!lesson[info.kkey]) {
            lesson[info.kkey] = [];
          }
        }

        for (const xcontent of this.contents) {
          this.lesson.ref
            .collection(xcontent.childCollection)
            .orderBy("createdAt", "desc")
            .onSnapshot((querySnapshot) => {
              if (!querySnapshot.empty) {
                xcontent.datas = [];
                querySnapshot.forEach((doc) => {
                  let content = doc.data();
                  content.ref = doc.ref;
                  content.id = doc.id;
                  xcontent.datas.push(content);
                });
              }
            });
        }
      });
    },
  },
  props: {
    xpath: {
      type: String,
      required: true,
    },
  },
};
</script>
<style>
.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 44px;
}
</style>